/**
 * UnlockPage.tsx
 * --------------
 * Page wrapper for the Wi-Fi unlock instructions.
 */


import Layout from '../components/common/Layout';
import Unlock from '../components/Unlock/Unlock';

const UnlockPage = () => {

  return (
    <Layout>
      <Unlock />
    </Layout>
  );
};

export default UnlockPage;
